<script setup></script>

<template>
  <div class="container">
    <p>{{ $t('alert_not_found_page') }}</p>
    <!--        <button class="btn">버튼메세지</button>-->
    <div class="info-sconai">
      <p class="smaller">Provided with</p>
      <p class="smaller-semibold">SconAI</p>
    </div>
  </div>
</template>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 30rem;
  height: calc(100dvh);
  justify-content: center; /* Vertically center */
  align-items: center; /* Horizontally center */
  text-align: center;
  margin: auto;
  padding: 2rem;
  padding-bottom: 4rem;
  gap: 1rem;
}
.info-sconai {
  display: flex;
  gap: 0.2rem;
  margin-top: 1.5rem;
  color: var(--color-gray-100);
  text-wrap: nowrap;
}
</style>

<!-- 메세지
1. 없는 경로에 들어갔을 때 : 잘못된 경로입니다. 주소를 확인 해 주세요. 버튼 : 스콘챗 홈으로 가기 
    리디렉션 : 일반 손님 - Entrance, Admin/호스트- home dashboard 
2. 페이지 자체에 갑자기 에러가 났을때 : 에러가 발생하였습니다. 잠시후 다시 시도 해 주세요. 버튼 : 뒤로가기
    리디렉션 : 이전 페이지
-->
